export default "__VITE_ASSET__9db6b98c__"